import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1386be27")

_pushScopeId("data-v-1386be27")
const _hoisted_1 = { class: "fridgedetails-tab" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsTabsItem = _resolveComponent("FridgeDetailsTabsItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
      return (_openBlock(), _createBlock(_component_FridgeDetailsTabsItem, {
        class: "fridgedetails-tab-item",
        key: item.index,
        index: item.index,
        title: item.title,
        selected: item.selected,
        onSelectTabIndex: _ctx.selectItem
      }, null, 8, ["index", "title", "selected", "onSelectTabIndex"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})